<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/muFKgy/images/cover.jpg?1684515570756" alt="This image is the cover for the book Full Darkness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Full Darkness
      </h1>
      <p class="bookDescription body article font2">
        <p><i>A theological treatment of war, trauma, and the fundamental character of human existence</i></p><p><i> </i>In <i>Full Darkness </i>theologian and wartime veteran Brian Powers argues that the Augustinian concept of original sin can illuminate the nature of wartime violence, particularly through the lens of veteran trauma. He shows precisely how sin and war both cause human identity, agency, and hope to be lost.</p><p>Powers explores sin as a pathogenic disfigurement that shapes cultural values and ethical ideas, frequently resulting in moral injury. Combat veterans experience a humanity deprived of grace and are devoured by the forces of war, often suffering post-traumatic stress disorder. But Powers provides a ray of hope and a path towards healing.</p>Ideal for veterans, chaplains, and pastors, <i>Full Darkness </i>offers a new perspective on the cultural understanding of military violence, provides theological help for those drowning in guilt and shame, and paves the way for reclaiming positive human agency and identity.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian S. Powers, John Swinton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13d8897a